import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { JSONRenderRoot } from "./JSONRender";

export const LogInspectorValues = observer(
  ({
    paneId,
    values,
    variableName,
    areValuesReversed = false,
  }: {
    paneId: string;
    values: any[];
    variableName?: string;
    areValuesReversed?: boolean;
  }) => {
    const [maxRowsToShow, setMaxNumRowsToShow] = useState(16);

    return (
      <div className="select-text">
        {values.slice(0, maxRowsToShow).map((value, i) => (
          <div
            className="border-t border-neutral-100 px-2 py-1 first:border-t-0 relative group transition"
            key={i}
          >
            <div className="font-mono-natto text-2xs uppercase text-neutral-400 mb-0.5 select-none">
              log {areValuesReversed ? values.length - i : i + 1}
            </div>
            <JSONRenderRoot
              paneId={paneId}
              value={value}
              isLogInspector={true}
              logInspectorName={variableName}
            />
            <div className="absolute top-0 bottom-0 left-0 w-px opacity-0 group-hover:opacity-100 bg-primary-400 transition" />
          </div>
        ))}
        {values.length > maxRowsToShow ? (
          <div className="border-t border-neutral-100">
            <button
              onClick={() => {
                setMaxNumRowsToShow((v) => v + 16);
              }}
              className="p-2 block w-full text-left text-primary-400 hover:text-primary-500 transition"
            >
              show more... ({maxRowsToShow} of {values.length})
            </button>
          </div>
        ) : null}
      </div>
    );
  }
);
